// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

// UI
export const SIDEBAR_WIDTH = 230;
// Character limits
export const DEFAULT_CHARACTER_LIMIT = 5000;
export const APPLICATION_STATEMENT_CHARACTER_LIMIT = 5000;
export const REJECTED_NOTE_CHARACTER_LIMIT = 250;
// Date thresholds
export const DEFAULT_SALARY_ACCOUNT_DATE_THRESHOLD = 1;
export const DEFAULT_CONSULTANCY_ACCOUNT_DATE_THRESHOLD = 1;

export const SnackMessage = {
  success: {
    submitBankAccount: "Successfully submitted bank account",
    updateBankAccount: "Successfully updated bank account",
  },
  error: {
    fetchAppConfigMessage: "Unable to retrieve app configurations",
    filteredBankAccounts: "Unable to retrieve list of filtered bank accounts",
    allBankAccountsMessage: "Unable to retrieve all bank accounts",
    requestedSalaryBankAccountsMessage:
      "Unable to retrieve list of requested salary bank accounts",
    activeBankAccountsMessage:
      "Unable to retrieve list of active bank accounts",
    updateBankAccount: "Unable to update bank account",
    fetchEmployeeInfoMessage: "Unable to retrieve employee information",
    fetchEmployeesMessage: "Unable to retrieve all employees",
    fetchBankAccountsMessage: "Unable to retrieve employee accounts",
    fetchBanksMessage: "Unable to retrieve list of banks",
    submitBankAccountMessage: "Unable to submit bank account",
    fetchPaymentMethodsMessage: "Unable to retrieve payment methods",
  },
  warning: {},
};

export const UIMessages = {
  loading: {
    loadingAppConfig: "Loading application configurations...",
    checkActiveBankInformation: "Checking active bank information...",
    checkAllBankInformation: "Checking all bank accounts...",
    checkEmployeeInfo: "Checking employee information...",
    checkBanks: "Checking bank information...",
    checkBranches: "Checking bank branches information...",
    submitChangeRequest: "Submitting bank account change request...",
    loadingBankAccounts: "Loading bank accounts...",
    loadingRequestedBankAccounts: "Loading requested bank accounts...",
    loadingBanks: "Loading banks...",
    filteredBankAccounts: "Loading filtered bank accounts...",
    loadingEmployees: "Loading employees...",
    updateBankAccountStatus: "Updating bank account status...",
  },
  error: {
    appConfig: "Error occurred while loading application configurations.",
    requestSummary: "Error occurred while loading summary.",
    allBankAccounts:
      "An unexpected error occurred while loading bank accounts.",
    requestedBankAccounts:
      "An unexpected error occurred while loading requested bank accounts.",
    banks: "An unexpected error occurred while loading banks.",
    employees: "An unexpected error occurred while loading employees.",
    bankAccountSubmit: "Failed to submit bank account change request!",
    bankAccountUpdate: "Failed to update bank account status!",
    requestCancel: "Request canceled.",
    noData: "No data found.",
    updateBankAccountStatus: "Failed to update bank account status.",
    filteredBankAccounts:
      "An unexpected error occurred while loading filtered bank accounts.",
    activeBankAccounts:
      "An unexpected error occurred while loading active bank accounts.",
    updateThreshold: "Failed to update threshold date.",
  },
  emptyRecords: {
    applicationHistory: "No bank account history found.",
  },
  common: {
    somethingWentWrong: "Oops! Something went wrong.",
  },
  success: {
    appConfigFetch: "Successfully fetched app configurations!",
    allBankAccountFetch: "Successfully fetched all bank accounts!",
    bankAccountActiveFetch: "Successfully fetched active bank accounts!",
    bankAccountUpdate: "Successfully updated bank account!",
    bankAccountsRequestedFetch: "Successfully fetched requested bank accounts!",
    bankFetch: "Successfully fetched banks!",
    employeeFetch: "Successfully fetched employees!",
    bankAccountSubmit: "Successfully submitted bank account change request!",
    bankAccountUpdateStatus: "Successfully updated bank account status!",
    filteredBankAccounts: "Successfully fetched filtered bank accounts!",
    thresholdUpdate: "Successfully updated threshold!",
  },
  processing: {
    bankAccount: "Submitting bank account...",
  },
};
